import { createAction } from "@reduxjs/toolkit";
import { dispositionListApiType } from "../../types/tempTypes";

export const getDispositionList = createAction<dispositionListApiType>(
  "temp/getDispositionList"
);
